import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { URLserver } from '../services/urlServer';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const loginUser = async (username, password) => {
    try {
      const response = await fetch(`${URLserver}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
  
      if (response.ok) {
        const data = await response.json();
        setUser(data);  // Guarda el usuario autenticado en el estado
        localStorage.setItem('user', JSON.stringify(data));  // Almacena el usuario en localStorage
        return true; // Devuelve true si el login fue exitoso
      } else {
        console.error('Credenciales incorrectas');
        return false; // Devuelve false si el login falla
      }
    } catch (error) {
      console.error('Error en el inicio de sesión', error);
      return false; // Devuelve false si ocurre un error
    }
  };

  // Función para cerrar sesión
  const logoutUser = async(token) => {
    try {
      const response = await fetch(`${URLserver}logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        },
      });
  
      if (response.ok) {
        setUser(null);
        localStorage.removeItem('user');
        return true; // Devuelve true si el login fue exitoso
      }
    } catch (error) {
      console.error('Error en el cierre de sesión', error);
      return false; // Devuelve false si ocurre un error
    }
  };

  return (
    <AuthContext.Provider value={{ user, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};
